import { FunctionComponent } from 'react'
import { Form } from 'react-bootstrap'

import { useOptionalHospitalAdmin } from '../hospitalAdminContext'

/**
 * Lets a hospital admin switch between the hospitals they manage.
 * Renders nothing when there is only one hospital.
 */
const ManagedHospitalSelect: FunctionComponent<{
  id?: string
  className?: string
}> = ({ id = 'managed-hospital', className }) => {
  const context = useOptionalHospitalAdmin()

  if (!context || context.managedHospitals.length <= 1) {
    return null
  }

  return (
    <Form.Select
      id={id}
      className={className}
      style={{ width: 'auto', minWidth: '14rem' }}
      aria-label="Hospital"
      value={context.selectedHospital?.hospitalId ?? ''}
      onChange={(event) => {
        const hospitalId = Number.parseInt(event.target.value, 10)
        const hospital = context.managedHospitals.find(
          (item) => item.hospitalId === hospitalId
        )

        if (hospital) {
          context.selectHospital(hospital)
        }
      }}
    >
      <option value="" disabled>
        Selecione o hospital
      </option>
      {context.managedHospitals.map((hospital) => (
        <option key={hospital.hospitalId} value={hospital.hospitalId}>
          {hospital.hospital}
        </option>
      ))}
    </Form.Select>
  )
}

export default ManagedHospitalSelect
